import { useHistory } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';

import TileForm from '../../../shared/TileForm/TileForm.jsx';
import { useSearchParams } from '../hooks/useSearchParams';
import { useFetchCampaign } from '../hooks/useFetchCampaign';
import { useScrollToStart } from '../hooks/useScrollToStart';

export const CampaignNewTileForm = ({ campaignId }) => {
  useScrollToStart();
  const history = useHistory();
  const queryClient = useQueryClient();
  const query = useSearchParams();
  const postId = query.get('post_id');
  const position = query.get('position');
  const { campaign } = useFetchCampaign({ id: campaignId });

  const isInPlanPage = window.location.pathname.includes('/plan');
  const prefix = isInPlanPage ? '/campaigns' : '';

  const onClose = () => {
    history.push(`${prefix}/${campaignId}/edit`);
  };

  const onSave = () => {
    queryClient.invalidateQueries(['shelfTiles'], { refetchInactive: true });
  };

  window.Airbo.Utils.trackPage({
    page: 'TileNewForm',
    campaign_id: campaignId,
    campaign_name: campaign.name,
  });

  return (
    <TileForm
      campaignId={campaignId}
      postId={postId}
      position={position}
      onSave={onSave}
      onClose={onClose}
    />
  );
};
